import React from 'react';
import { useReveal } from '../../hooks/useReveal';

export const Section = ({
  id,
  eyebrow,
  title,
  subtitle,
  align = 'left',
  className = '',
  innerClassName = '',
  children,
  showRule = false,
}) => {
  const [ref, inView] = useReveal();
  const alignment = align === 'center' ? 'text-center mx-auto items-center' : '';
  return (
    <section
      id={id}
      ref={ref}
      className={`relative py-14 sm:py-20 md:py-28 ${className}`}
    >
      <div className={`container ${innerClassName}`}>
        {(eyebrow || title || subtitle) && (
          <div className={`max-w-3xl mb-8 sm:mb-12 md:mb-16 ${align === 'center' ? 'mx-auto text-center' : ''}`}>
            {eyebrow && (
              <div className={`reveal ${inView ? 'in' : ''} mb-4`}>
                <Eyebrow label={eyebrow} />
              </div>
            )}
            {title && (
              <h2
                className={`reveal ${inView ? 'in' : ''} text-display text-app font-bold text-display-lg`}
                style={{ transitionDelay: '60ms' }}
              >
                {title}
              </h2>
            )}
            {subtitle && (
              <p
                className={`reveal ${inView ? 'in' : ''} text-muted text-lg leading-relaxed mt-5`}
                style={{ transitionDelay: '120ms' }}
              >
                {subtitle}
              </p>
            )}
          </div>
        )}
        {showRule && <div className="h-px w-full bg-app mb-12" style={{ background: 'var(--border)' }} />}
        {children}
      </div>
    </section>
  );
};

export const Eyebrow = ({ label }) => (
  <span className="inline-flex items-center gap-2">
    <span className="h-px w-8" style={{ background: 'var(--border-strong)' }} />
    <span className="eyebrow">{label}</span>
  </span>
);

export default Section;
